import { curry, flow, filter, get } from 'lodash/fp';

export default curry((designId, allItems) => flow(
  filter({ designId }),
  filter(get('itemProduct')),
)(allItems));
